<template>
  <div style="margin: 10px">
    <div class="page-back">
      <button class="btn btn-sm btn-primary" @click="$router.go(-1)">
        <img src="../../../static/assets/img/left-arrow.png" width="30"/>
        <span class="btn-text"></span>
      </button>
    </div>
    <table border="0" cellspacing="0" cellpadding="1" width="100%" v-if="bet">
      <thead>
      <tr>
        <th>No.: {{ bet.id }}</th>
        <th v-if="bet.result">{{ t.betting.title.status }}: {{ bet.result.name }}</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>IP</td>
        <td></td>
      </tr>
      <tr class="even">
        <td>{{ t.user.groups.ROLE_CLIENT }}:</td>
        <td>
          <router-link :to="{name: 'CustomerDetail', params: {id: bet.user_id}, query: {referrer: bet.reseller}}" target='_blank'>
            {{ $route.query.username }} ( {{ $route.query.name }} )
          </router-link>
        </td>
      </tr>
      <tr class="odd">
        <td>{{ t.created_at}}</td>
        <td align="right">{{ dateTimeFormat(bet.created_at) }}</td> <!-- tr -->
      </tr>
      <tr class="even">
        <td>{{ t.last_update }}:</td> <!-- tr -->
        <td align="right">{{ dateTimeFormat(bet.updated_at) }}</td>
      </tr>
      <tr class="even">
        <td> Id</td>
        <td align="right">{{ bet.id }}</td>
      </tr>
      <tr class="odd">
        <td>{{ t.bet }}:</td>
        <td align="right">{{ bet.bet_count }} x {{ bet.amount_per_bet }} = {{ bet.amount | toMoney(session.currency)  }}</td>
      </tr>
      <tr class="even">
        <td>{{ t.betting.title.stake }}:</td> <!-- tr -->
        <td align="right">{{ bet.amount | toMoney(session.currency)  }}</td>
      </tr>
      <tr class="odd">
        <td>{{ t.total_odd }}:</td>
        <td align="right">{{ bet.multiplier }}</td>
      </tr>
      <tr class="even">
        <td>{{ t.betting.title.possible_earnings }}:</td>
        <td align="right"><b>{{ bet.earnings | toMoney(session.currency) }}</b></td>
      </tr>
      <tr>
        <td>{{ t.transactions.status.payed }}:</td>
        <td align="right">{{ bet.calculated_earnings | toMoney(session.currency) }}</td>
      </tr>
      <tr class="even">
        <td>Cashout:</td>
        <td align="right">{{ bet.cashout_amount | toMoney(session.currency) }}</td>
      </tr>
      <tr class="odd">
        <td>{{ t.betting.type.system }}:</td> <!-- tr -->
        <td align="right">
            {{ t.betting.type[bet.type.name] }}
						<span v-if="bet.type.name == 'system'">
							({{ bet.combinations }})
						</span>
        </td>
      </tr>
      </tbody>
    </table>
    <table border="0" cellspacing="0" cellpadding="1" width="100%">
      <tbody>
      <tr>
        <th>No.</th>
        <th>{{ t.event }}</th>
        <th class="">{{ t.results }}</th> <!-- tr -->
        <th class="text-lg-right">ODD</th>  <!-- tr -->
      </tr>
      <div style="display: contents" v-for="(match, idx) in matches" :key="idx">
        <tr class="even">
          <td align="left">{{ match.mid }}</td>
          <td colspan="1">{{ match.fcName }} - {{ match.scName }}</td>
          <td>
            <span v-if="match.mData.score">
              {{ match.mData.score.home }}:{{ match.mData.score.away }}
            </span>
          </td>
          <td>
          </td>
        </tr>
        <tr :class="match.oddResult ">
          <td align="right"></td>
          <td>
            {{ moment(match.matchStartDate).local().format("L") + ' ' +moment(match.matchStartDate).local().format("LT") }}
            <template v-if="match.isLive">
              | {{ periodTimer({periodTimeLeft: 0, periodTime: match.periodTime}) }} / ({{ match.betResult }})
            </template>
          </td>
          <td>
            {{ match.name }}: <strong>{{ match.selection }} {{ match.specialValue }}</strong>
            <template v-if="match.isLive"> (Live {{match.betData.score.home}}: {{match.betData.score.away}})</template>
          </td>
          <td align="right">
            {{match.oddValue}}
          </td>
        </tr>
      </div>
      </tbody>
    </table>
    <table style="border:none;" border="0" cellpadding="1" cellspacing="0">
      <tbody>
      <tr>
        <td class="waiting">{{ t.betting.waiting }}</td>
        <td class="win">{{ t.betting.win }}</td>
        <td class="loss">{{ t.betting.loss }}</td>
        <td class="cancelled">{{ t.betting.cancelled }}</td>
        <td class="buyback">{{ t.betting.refund }}</td>
        <td class="win">{{ t.betting.cashout }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "CouponDetail",
  data() {
    return {
      bet: [],
      matches: [],
      notfound: 0,
      session: session,
      t: this.$root.t,
      loading: false,
    }
  },
  mounted() {
    this.fetchBet()
  },
  methods: {
    async fetchBet() {
      this.loading = true;
      this.$http.get(bsapi + 'api/v1/bet/detail/' + this.$route.params.coupon_id)
          .then(response => {
            this.bet = response.body.result.bet;
            this.matches = response.body.result.items;
            this.loading = false;
          }, response => {
            this.notfound = 1;
            this.loading = false;
          })
    },
    sToMin(match) {
      if(Number(match.periodTimeLeft) > 0) {
        return this.convertTime(match.periodTimeLeft);
      }else {
        const min = (Number(match.periodTime) / 60).toFixed(0);
        return (min > 0) ? min+"'" : '';
      }
    },
    convertTime(sec) {
      var hours = Math.floor(sec/3600);
      (hours >= 1) ? sec = sec - (hours*3600) : hours = '00';
      var min = Math.floor(sec/60);
      (min >= 1) ? sec = sec - (min*60) : min = '00';
      (sec < 1) ? sec='00' : void 0;

      (min.toString().length == 1) ? min = '0'+min : void 0;
      (sec.toString().length == 1) ? sec = '0'+sec : void 0;

      return hours+':'+min+':'+sec;
    }
  }
}
</script>

<style scoped>body {
  font-family: sans-serif;
  font-size: 10pt;
}

table {
  border: 1px solid;
  border-width: 1px
}

th {
  background-color: #F1F0E3;
  font-size: 10pt;
}

td {
  font-size: 10pt;
  padding: 5px;
}

.bank {
  text-decoration: underline;
}

.waiting, .open-even {
  color: #000000;
}

.win, .won-even {
  color: #248700;
}

.loss, .lost-even {
  color: #ff0000;
}

.buyback, .buyback-even {
  color: #F88017;
}

.bought-back, .bought-back-even {
  color: #F88017;
}
.pending, .pending-even {
  color: #DC00DC;
}

.baseless, .baseless-even {
  color: #960096;
}

.requested, .requested-even {
  color: #000080;
}

.allowed, .allowed-even {
  color: #008000;
}

.rejected, .rejected-even {
  color: #808080;
}

.cancelled, .canceled-even, .refund {
  color: #0d00ff;
}

.payback, .payback-even {
  color: #00DC00;
}

.invalid, .invalid-even {
  color: #9F6C33;
}

.payout, .payout-even {
  color: #FF0000;
}

.paid-out, .paid-out-even {
  color: #960000;
}

.paid-back, .paid-back-even {
  color: #009600;
}

.expired, .expired-even {
  color: #9B9B64;
}

.odd {
  background: #F1F1F1;
}

.even {
  background: #FFFFFF;
}

.open-odd {
  color: #000000;
  background: #F1F1F1;
}

.won-odd {
  color: #D80000;
  background: #F1F1F1;
}

.lost-odd {
  color: #0096FF;
  background: #F1F1F1;
}

.buyback-odd {
  color: #F88017;
  background: #F1F1F1;
}

.bought-back-odd {
  color: #F88017;
  background: #F1F1F1;
}

.pending-odd {
  color: #DC00DC;
  background: #F1F1F1;
}

.baseless-odd {
  color: #960096;
  background: #F1F1F1;
}

.requested-odd {
  color: #000080;
  background: #F1F1F1;
}

.allowed-odd {
  color: #008000;
  background: #F1F1F1;
}

.rejected-odd {
  color: #808080;
  background: #F1F1F1;
}

.canceled-odd {
  color: #808080;
  background: #F1F1F1;
}

.payback-odd {
  color: #00DC00;
  background: #F1F1F1;
}

.invalid-odd {
  color: #9F6C33;
  background: #F1F1F1;
}

.payout-odd {
  color: #FF0000;
  background: #F1F1F1;
}

.paid-out-odd {
  color: #960000;
  background: #F1F1F1;
}

.paid-back-odd {
  color: #009600;
  background: #F1F1F1;
}

.expired-odd {
  color: #9B9B64;
  background: #F1F1F1;
}

.btn-text {
  margin-left: 5px;
  font-size: 16px;
  font-weight: 700;
}

.page-back {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/CouponDetail.vue